import "./Offers.scss";
import { DownloadIcon, FolderIcon, DescriptionIcon } from "../../../../shared/margincalculator/components/icons/Icon";

function Offers() {
  return (
    <div className="offers">
      <header className="offers__header-top">
        <div className="offers__title-group">
          <h1>Meine Angebote</h1>
          <p>Alle gespeicherten Angebote (0)</p>
        </div>
        <div className="offers__actions">
          <button className="offers__btn-export">
            <DownloadIcon /> CSV Export
          </button>
        </div>
      </header>

      <div className="offers__search">
        <input type="text" placeholder="Angebote durchsuchen..." />
      </div>

      <div className="offers__list-card">
        <div className="offers__list-card__header">
          <h3>
            <FolderIcon /> Angebotsliste
          </h3>
        </div>

        <div className="offers__list-card__empty-state">
          <DescriptionIcon />
          <p>
            Keine Angebote gefunden
            <br />
            <span>Erstellen Sie Ihr erstes Angebot im Kalkulator</span>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Offers;
